
 // src/modules/user/services/invoiceService.js

import api from '../../../services/api';

const BASE_URL = '/invoices';

const DEFAULT_PAGINATION = {
  page: 1,
  limit: 10,
  total: 0,
  totalPages: 0,
};

const invoiceService = {
  async getInvoices(params = {}) {
    const response = await api.get(BASE_URL, { params });
    const result = response.data?.data;

    return {
      invoices: Array.isArray(result)
        ? result
        : Array.isArray(result?.invoices)
          ? result.invoices
          : [],
      pagination: {
        ...DEFAULT_PAGINATION,
        ...(response.data?.pagination || result?.pagination || {}),
      },
    };
  },

  async getInvoiceByNumber(invoiceNumber) {
    if (!invoiceNumber) {
      throw new Error('Invoice number is required.');
    }

    const response = await api.get(
      `${BASE_URL}/${encodeURIComponent(invoiceNumber)}`
    );

    const result = response.data?.data;

    return result?.invoice ?? result ?? null;
  },

  async downloadInvoicePdf(invoiceNumber) {
    if (!invoiceNumber) {
      throw new Error('Invoice number is required.');
    }

    const response = await api.get(
      `${BASE_URL}/${encodeURIComponent(invoiceNumber)}/pdf`,
      { responseType: 'blob' }
    );

    const blob = new Blob([response.data], {
      type: 'application/pdf',
    });

    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = blobUrl;
    link.download = `${invoiceNumber}.pdf`;

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.setTimeout(() => {
      window.URL.revokeObjectURL(blobUrl);
    }, 1000);
  },

  async createInvoice(invoiceData) {
    if (
      !invoiceData ||
      typeof invoiceData !== 'object' ||
      !Array.isArray(invoiceData.items) ||
      invoiceData.items.length === 0
    ) {
      throw new Error('An invoice must contain at least one item.');
    }

    const response = await api.post(BASE_URL, invoiceData);
    const result = response.data?.data;

    return result?.invoice ?? result ?? null;
  },
};

export default invoiceService;
